var constants = require('../constants');
var progress = require('./surveys-update-progress');

var UpdateSequence = (function() {

    var _updateSequenceIndex = function(index) {
        return function(dispatch){
            dispatch({
                type: constants.UPDATE_SEQUENCE_INDEX,
                currentSequenceIndex: index
            });
            dispatch(progress.updateSurveyProgress());
        };
    }

    return {
        updateSequenceIndex: _updateSequenceIndex
    }
})();

module.exports = UpdateSequence;



// WEBPACK FOOTER //
// ./src/common/modules/survey/actions/surveys-update-sequence.js